import { motion } from 'framer-motion';

export const BorderCard = ({ 
  children, 
  className = '', 
  onClick,
  hover = true,
  interactive = true,
  as = 'div',
  ...props 
}) => {
  const Component = motion[as] || motion.div;
  
  // Non-interactive cards (for reference only)
  if (!interactive) {
    return (
      <div
        className={`bg-white border border-[rgba(26,26,26,0.1)] cursor-default ${className}`}
        {...props}
      >
        {children}
      </div>
    );
  }
  
  return (
    <Component
      className={`bg-white border border-[rgba(26,26,26,0.1)] transition-all duration-500 ${
        hover ? 'hover:border-[#1A1A1A] cursor-pointer' : 'cursor-default'
      } ${className}`}
      onClick={onClick}
      whileHover={hover ? { y: -4 } : {}}
      transition={{ duration: 0.3 }}
      {...props}
    >
      {children}
    </Component>
  );
};

export const ImageCard = ({ 
  image, 
  title, 
  onClick,
  className = '' 
}) => {
  return (
    <BorderCard 
      onClick={onClick}
      className={`overflow-hidden ${className}`}
    >
      <div className="relative overflow-hidden">
        <motion.img 
          src={image} 
          alt={title}
          className="w-full h-[250px] object-cover grayscale-[30%]"
          whileHover={{ scale: 1.02, filter: 'grayscale(0%)' }}
          transition={{ duration: 0.5 }}
        />
      </div>
      <div className="p-6">
        <h3 className="text-xs uppercase tracking-[0.15em] font-semibold">
          {title}
        </h3>
      </div>
    </BorderCard>
  );
};

// Static card for non-clickable content
export const StaticCard = ({ 
  children, 
  className = '',
  showLabel = false,
  ...props 
}) => {
  return (
    <div
      className={`bg-white border border-[rgba(26,26,26,0.08)] cursor-default ${className}`}
      {...props}
    >
      {children}
      {showLabel && (
        <div className="text-[9px] uppercase tracking-wider text-[#1A1A1A]/30 text-center pb-2 mt-2">
          For reference only
        </div>
      )}
    </div>
  );
};

// Training Reference Link component
export const TrainingReferenceLink = ({ href, label = "Training Reference Link", subtext = "Click to open training material" }) => {
  return (
    <div className="flex flex-col items-center gap-1">
      <a 
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-[#D32F2F] text-xs uppercase tracking-[0.15em] font-medium hover:underline hover:opacity-90 transition-all duration-300 group"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          width="14" 
          height="14" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300"
        >
          <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
          <polyline points="15 3 21 3 21 9"></polyline>
          <line x1="10" y1="14" x2="21" y2="3"></line>
        </svg>
        {label}
      </a>
      <span className="text-[10px] text-[#1A1A1A]/40">
        {subtext}
      </span>
    </div>
  );
};

export default BorderCard;
